import { nonEmpty, object, pipe, string, trim } from 'valibot';
import type { InferOutput } from 'valibot';

const FilledStringSchema = pipe(string(), trim(), nonEmpty('SEO field is empty'));
const StringSchema = string();

const SeoSchemaEntries = {
  title: FilledStringSchema,
  description: StringSchema,
  canonical: FilledStringSchema,
  robots: FilledStringSchema,
  og_image: FilledStringSchema,
  schema_recipe: StringSchema,
  schema_howto: StringSchema,
  schema_faq: StringSchema,
};

export const NoindexSeoSchema = object({
  title: FilledStringSchema,
  robots: FilledStringSchema,
});

export const SeoSchema = object({
  ...SeoSchemaEntries,
  schema: StringSchema,
});

export const ArticleSeoSchema = object({
  ...SeoSchemaEntries,
  schema: FilledStringSchema,
});

export const RecipeSeoSchema = object({
  ...SeoSchemaEntries,
  schema: FilledStringSchema,
  schema_recipe: FilledStringSchema,
});

export const RecipeArchiveSeoSchema = object({
  ...SeoSchemaEntries,
  schema: FilledStringSchema,
});

export type Seo = InferOutput<typeof SeoSchema>;
export type NoindexSeo = InferOutput<typeof NoindexSeoSchema>;
